import { render } from "./Sidebar.vue?vue&type=template&id=6ce93b4a"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bogdanov.ea/Documents/goast-auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__